import React from 'react';
import Usecase1 from '/Images/Usecase1.svg';
import Usecase2 from '/Images/Usecase2.svg';
import Usecase3 from '/Images/Usecase3.svg';
import Usecase4 from '/Images/Usecase4.svg';
import Usecase5 from '/Images/Usecase5.svg';
import Usecase6 from '/Images/Usecase6.svg';
import { useMediaQuery } from '@mui/material';

const UseCaseCards = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)', // 1 kolom di mobile, 3 di desktop
      gap: isMobile ? '20px' : '30px',
      padding: isMobile ? '20px' : '50px',
      backgroundColor: '#E7E4E2',
      justifyContent: 'center',
    },
    card: {
      maxWidth: isMobile ? '100%' : '402px',
      minHeight: isMobile ? 'auto' : '342px',
      padding: isMobile ? '20px' : '40px',
      paddingBottom: '20px',
      borderRadius: '10px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      backgroundColor: '#E7E4E2',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    icon: {
      width: isMobile ? '50px' : '85px',
      height: isMobile ? '50px' : '85px',
      marginBottom: isMobile ? '10px' : '20px',
      marginTop: isMobile ? '10px' : '20px',
    },
    title: {
      fontSize: isMobile ? '16px' : '20px',
      fontWeight: '600',
      color: '#214D73',
      marginBottom: '10px',
    },
    description: {
      fontSize: isMobile ? '0.875rem' : '1rem',
      color: '#6D6D6D',
      lineHeight: '1.5',
      maxWidth: '250px',
      minHeight: '75px',
    },
    header: {
      textAlign: 'center',
      marginBottom: isMobile ? '20px' : '40px',
      fontSize: isMobile ? '24px' : '40px',
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
    },
  };

  // Data untuk setiap kartu
  const cardsData = [
    {
      icon: Usecase1,
      title: 'Merchants',
      description:
        'Accept transfers and easily manage your funds using a secure custody platform.',
    },
    {
      icon: Usecase2,
      title: 'Neo Banks',
      description:
        'Secure your funds and operate with multi-layer protected wallet technology.',
    },
    {
      icon: Usecase3,
      title: 'Asset Managers',
      description:
        'Streamline assets management and benefit from advanced security and governance rules.',
    },
    {
      icon: Usecase4,
      title: 'Payment Gateways',
      description:
        'Manage vaults, addresses and get a complete 360-degree view of your digital assets.',
    },
    {
      icon: Usecase5,
      title: 'Investment Platforms',
      description:
        'Streamline investments with secure, scalable platforms for seamless transactions.',
    },
    {
      icon: Usecase6,
      title: 'Hedge Funds',
      description:
        'Protect and easily manage your funds with a secure custody technology solution.',
    },
  ];

  return (
    <div style={{ padding: isMobile ? '20px' : '80px', backgroundColor: '#E7E4E2' }}>
      {/* Header */}
      <h2 style={styles.header}>
        From Ideas to Impact <br />
        Discovering Effective Use Cases
      </h2>

      {/* Grid Cards */}
      <div style={styles.container}>
        {cardsData.map((card, index) => (
          <div key={index} style={styles.card}>
            <img src={card.icon} alt={card.title} style={styles.icon} />
            <h3 style={styles.title}>{card.title}</h3>
            <p style={styles.description}>{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UseCaseCards;
